import Events from "./components/events_archive";

(function ($) {
	const categories = document.querySelector('.hpy--product_categories');

	if (categories) {
		let splide = new Splide(categories, {
			pagination: false,
			focus: 0,
			omitEnd: true,
			fixedWidth: 'clamp(9.375rem,8.5714285714rem + 2.6785714286vw,11.25rem)',
			gap: 'clamp(1rem,0.5714285714rem + 1.4285714286vw,2rem)',
			autoHeight: true
		});

		splide.on('overflow', function (isOverflow) {
			splide.options = {
				arrows: isOverflow,
				drag: isOverflow
			}
		});

		splide.mount();
		splide.event.emit('overflow', splide.Components.Layout.isOverflow())
	}

	if (document.querySelector('#gr-events--sidebar')) {
		new Events();
	}


}(jQuery));